/**
 * Neutral default theme — no Pentecost+ brand hardcoding.
 */
export var defaultTheme = {
  colors: {
    background: "#0b0b0c",
    surface: "rgba(0,0,0,0.65)",
    accent: "#e50914",
    text: "#ffffff",
    muted: "rgba(255,255,255,0.7)",
    progress: "#ffffff",
    buffer: "rgba(255,255,255,0.35)",
  },
  typography: {
    fontFamily:
      'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: "14px",
  },
  controls: {
    height: 48,
    borderRadius: 4,
    showOnHover: true,
  },
  branding: {
    wordmark: null,
    accentOverride: null,
  },
};

export default defaultTheme;
